export const init = () => {

  // TRACKER 'BASKET'
  const tracker = new AnalyticsTracker(AnalyticsConstants.trackers.funnel.savelater);
  const sep = AnalyticsConstants.separatorST;
  const fwk = CUBE.Analytics;

  const getModel = $element => {
    let model;
    let refId;
    const $eltProduct = $element.closest('.faux-table-wrapper');
    const $eltProducts = $element.closest('.table-wrapper').find('.faux-table-wrapper');
    //refId = $eltProduct.find('[data-product-reference]').data('product-reference');
    refId = $eltProduct.find('[data-model-id]').data('model-id');
    if (!refId) refId = $eltProduct.find('[data-modelid]').data('modelid');
    model = fwk.utils.datalayer.getModel(refId);
    if (Object.keys(model).length === 0) {
      model = fwk.utils.datalayer.getModel(tc_vars.order_products[$eltProducts.index($eltProduct)].order_product_id_model);
      if (refId) {
        model.modelId = refId;
        model.id = refId;
      }
    }
    model.position = $eltProducts.index($eltProduct) + 1;
    return model;
  };

  const getProductDetails = function($element) {
    const model = getModel($element);
    this.model = model;
    return model.variant + sep + model.name + sep + model.modelId;
  };
  const getProductValue = function() { return this.model.price;};


  // Save to 'Buy Later'
  const addToSaveLater = new AnalyticsClickEvent('addToSaveLater', tracker.defaultEvent());
  addToSaveLater.domContainer = '#cartridgeDivId';
  addToSaveLater.domElement = '.buy-later-btn';
  addToSaveLater.options.action = 'AddToSavedForLater';
  addToSaveLater.getLabel = function($element) {return getProductDetails.bind(this)($element);};
  addToSaveLater.getValue = function($element) {return getProductValue.bind(this)($element);};
  tracker.addEvent(addToSaveLater);

  // Move to Cart
  const removeFromSaveLater = new AnalyticsClickEvent('removeFromSaveLater', tracker.defaultEvent());
  removeFromSaveLater.domContainer = '#cartridgeDivBuyLaterId';
  removeFromSaveLater.domElement = '.buy-later-to-cart-btn';
  removeFromSaveLater.options.action = 'AddToCart';
  removeFromSaveLater.getLabel = function($element) {
    return getProductDetails.bind(this)($element);
  };
  removeFromSaveLater.getValue = function($element) {return getProductValue.bind(this)($element); };
  tracker.addEvent(removeFromSaveLater);

  // Delete All Wishlist
  const deleteAllWishlist = new AnalyticsClickEvent('deleteAllWishlist', tracker.defaultEvent());
  deleteAllWishlist.domContainer = '#cartridgeDivBuyLaterId';
  deleteAllWishlist.domElement = '#delete-all-products, .delete-products.js-delete-all-from-buy-later';
  deleteAllWishlist.options.action = 'DeleteAllSavedForLater';
  deleteAllWishlist.options.label = '';
  tracker.addEvent(deleteAllWishlist);

  // Delete 1 product
  const deleteOneFromWishlist = new AnalyticsClickEvent('deleteOneFromWishlist', tracker.defaultEvent());
  deleteOneFromWishlist.domContainer = '#cartridgeDivBuyLaterId';
  deleteOneFromWishlist.domElement = '.js-delete-from-buy-later';
  deleteOneFromWishlist.options.action = 'DeleteOneSavedForLater';
  deleteOneFromWishlist.getLabel = function($element) {return getProductDetails.bind(this)($element);};
  deleteOneFromWishlist.getValue = function($element) {return getProductValue.bind(this)($element);};
  tracker.addEvent(deleteOneFromWishlist);

  // Go back to 1 product
  const savelaterGoBackToProduct = new AnalyticsClickEvent('savelaterGoBackToProduct', tracker.defaultEvent());
  savelaterGoBackToProduct.domContainer = '#cartridgeDivBuyLaterId';
  savelaterGoBackToProduct.domElement = '.product-img a';
  savelaterGoBackToProduct.options.action = 'GoBackToProduct';
  savelaterGoBackToProduct.getLabel = function($element) {return getProductDetails.bind(this)($element);};
  tracker.addEvent(savelaterGoBackToProduct);

  //---------------
  /*
	// Modify 1 article (from cart)
	var modifyOneFromCart = new AnalyticsClickEvent('modifyOneFromCart', tracker.defaultEvent());
	modifyOneFromCart.domContainer = '#cartridgeDivId';
	modifyOneFromCart.domElement = '.modify-product';
	modifyOneFromCart.options.action = 'ModifyProduct';
	modifyOneFromCart.getLabel = function($element){
		return getProductDetails.bind(this)($element);
	};
	modifyOneFromCart.getValue = function($element) {
		return getProductValue($element);
	};
	tracker.addEvent(modifyOneFromCart);

	// Confirmation article modification
	var confirmModifyOneFromCart = new AnalyticsClickEvent('confirmModifyOneFromCart', tracker.defaultEvent());
	confirmModifyOneFromCart.domContainer = '#cartridgeDivId';
	confirmModifyOneFromCart.domElement = '#confirm_modification';
	confirmModifyOneFromCart.options.action = 'ConfirmModifyProduct';
	confirmModifyOneFromCart.getLabel = function($element){
		return getProductDetails.bind(this)($element);
	};
	confirmModifyOneFromCart.getValue = function($element) {
		return getProductValue($element);
	};
	tracker.addEvent(confirmModifyOneFromCart);
*/
  //----------------------
  // CrossSell - Move to cart
  //var eventAddToCartCrossSell = new AnalyticsEvent('virtualEventAddToCartCrossSell', tracker.defaultEvent());
  //tracker.addEvent(eventAddToCartCrossSell);

  CUBE.Analytics.trackers.add(tracker);
  CUBE.Analytics.trackers.init(tracker.params.name);
};



// WEBPACK FOOTER //
// ./src/analytics/trackers/funnel/savelater-tracker.js